import {Component, Injector} from "@angular/core";
import {Mediaset, Scenario, VOGSet, VTPSet} from "@models";
import {SimMediasetService, SimUtilityService} from "@services";
import {Translations} from "@translations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_DeleteMediaDialogInput extends MatDialogDataBaseInput {
	mediaId: string;
	mediaName: string;
}

@Component({
	selector: "sim-delete-media-dialog",
	templateUrl: "./delete-media-dialog.component.html",
	styleUrls: ["./delete-media-dialog.component.scss"],
	standalone: false,
})
export class DeleteMediaDialogComponent extends BasicMaterialDialog<
	DeleteMediaDialogComponent,
	DialogData_DeleteMediaDialogInput,
	MatDialogDataBaseOutput
> {
	T = Translations;

	affectedMediaSets: Mediaset[] = [];
	affectedScenarios: Scenario[] = [];
	affectedVogSets: VOGSet[] = [];
	affectedVtpSets: VTPSet[] = [];

	totalAffectedEntities: number = 0;
	loading: boolean = true;

	constructor(
		_injector: Injector,
		private _simMediaSetService: SimMediasetService,
	) {
		super(_injector);
	}

	async ngOnInit() {
		super.ngOnInit();

		const loadAffectedEntitiesTask = this._simMediaSetService.getAffectedEntitiesWhenRemoveMediaAndAllLinks(this.data.mediaId);

		let ret = await SimUtilityService.promiseTakeAtLeast(500, loadAffectedEntitiesTask);

		this.affectedMediaSets = ret.affectedMediaSets;
		this.affectedScenarios = ret.affectedScenarios;
		this.affectedVogSets = ret.affectedVogSets;
		this.affectedVtpSets = ret.affectedVtpSets;

		this.totalAffectedEntities =
			this.affectedMediaSets.length + this.affectedScenarios.length + this.affectedVogSets.length + this.affectedVtpSets.length;
		this.loading = false;
	}
}
